import { Button, Col, Divider, Row, Select, Tabs } from "antd";
import { useState } from "react";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./CustomerCoupons.module.scss";
import CustomerLayout from "../../Components/CustomerLayout/CustomerLayout";

const CustomerCoupons = () => {
    const [activeTab, setActiveTab] = useState("1");

    // set tab header based on active tab
    const setTabHeader = (activeTab) => {
        switch (activeTab) {
            case "1":
                return "Active Coupons";
            case "2":
                return "Used Coupons";
            case "3":
                return "Partner Coupons";
            default:
                return "Active Coupons";
        }
    };

    return (
        <>
            {window.innerWidth < 991 ? (
                <Layout>
                    <div className={styles.customer_coupon_container}>
                        <BreadCrumb
                            list={[
                                { name: "Home", link: "/" },
                                {
                                    name: setTabHeader(activeTab),
                                    link: `/customer/coupons`,
                                },
                            ]}
                        />
                        <div className="custom_coupon_tab">
                            <Tabs
                                defaultActiveKey="1"
                                tabPosition="top"
                                animated={{
                                    inkBar: true,
                                    tabPane: true,
                                }}
                                onChange={(key) => setActiveTab(key)}
                            >
                                <Tabs.TabPane tab="Active Coupons" key="1">
                                    <ActiveCoupons />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Used Coupons" key="2">
                                    <ActiveCoupons />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Partner Coupons" key="3">
                                    <ActiveCoupons />
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                    </div>
                </Layout>
            ) : (
                <CustomerLayout
                    breadcrumb={[
                        { name: "Back To Home", link: "/" },
                        {
                            name: "Coupons and Discounts",
                            link: `/customer/coupons`,
                        },
                        {
                            name: setTabHeader(activeTab),
                            link: `/customer/coupons`,
                        },
                    ]}
                >
                    <div className={styles.customer_coupon_container}>
                        <div className={styles.top_title}>
                            <img
                                src="https://desi-fresh.b-cdn.net/components_static/sidebar_icons/coupons-and-discounts-active.svg"
                                alt="coupon"
                                height={40}
                            />
                            <h3>Coupons and discounts</h3>
                        </div>

                        <div className={styles.helper_text}>
                            Coupon Redemption Policy and Return Policy for orders where a coupon was used. You can get a
                            50 PLN shopping voucher by recommending us to your friends!{" "}
                            <a href="/">Check the details.</a>
                        </div>

                        <div className={styles.tell_a_friend}>
                            <div className={styles.tell_a_friend_left}>
                                <h3>Tell a friend</h3>
                                <Select
                                    defaultValue="5"
                                    style={{ width: 150 }}
                                    options={[
                                        { value: "5", label: "5 €" },
                                        { value: "10", label: "10 €" },
                                    ]}
                                />
                            </div>
                            <Button>Subscribe Coupons</Button>
                        </div>
                        <div className="custom_coupon_tab">
                            <Tabs
                                defaultActiveKey="1"
                                tabPosition="top"
                                animated={{
                                    inkBar: true,
                                    tabPane: true,
                                }}
                                onChange={(key) => setActiveTab(key)}
                            >
                                <Tabs.TabPane tab="Active Coupons" key="1">
                                    <ActiveCoupons />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Used Coupons" key="2">
                                    <ActiveCoupons />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Partner Coupons" key="3">
                                    <ActiveCoupons />
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                        <Divider />
                    </div>
                </CustomerLayout>
            )}
        </>
    );
};

export default CustomerCoupons;

// make react components for each tab

const ActiveCoupons = () => {
    // dummy coupons data
    const coupons = [
        {
            id: 1,
            product: {
                id: 1,
                name: "Red Chilli Pickle",
                image: "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
                is_bio: true,
                is_vegan: true,
                is_new: true,
                brand: "Priya",
            },
            discount: "25",
            with_membership: false,
            valid_until: "15.03.2023",
            is_new: true,
            price: 0.99,
            discounted_price: 0.39,
        },
        {
            id: 2,
            product: {
                id: 1,
                name: "Red Chilli Pickle",
                image: "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
                is_bio: false,
                is_vegan: true,
                is_new: true,
                brand: "Priya",
            },
            discount: "25",
            with_membership: true,
            valid_until: "15.03.2023",
            price: "0.99",
            discounted_price: "0.39",
        },
        {
            id: 3,
            product: {
                id: 1,
                name: "Red Chilli Pickle",
                image: "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
                is_bio: true,
                is_vegan: false,
                is_new: true,
                brand: "Dev",
            },
            discount: "32",
            with_membership: true,
            valid_until: "18.03.2023",
            price: 0.99,
            discounted_price: 0.39,
        },
        {
            id: 4,
            product: {
                id: 1,
                name: "Red Chilli Pickle",
                image: "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
                is_bio: true,
                is_vegan: true,
                is_new: false,
                brand: "Dev",
            },
            discount: "29",
            with_membership: true,
            valid_until: "18.03.2023",
            price: 0.99,
            discounted_price: 0.39,
        },
    ];

    return (
        <div className={styles.active_coupons}>
            <Row gutter={[20, 20]}>
                {coupons.map((coupon, i) => (
                    <Col xs={24} md={12} lg={12}>
                        <CouponComponent coupon={coupon} key={i} />
                    </Col>
                ))}
            </Row>
            <div className={styles.see_more_btn}>
                <Button> See More </Button>
            </div>
        </div>
    );
};

// will add these 2 one when api is ready
// const UsedCoupons = () => {
//   return <div>Used Coupons</div>;
// };

// const PartnerCoupons = () => {
//   return <div>Partner Coupons</div>;
// };

export const CouponComponent = ({ coupon }) => {
    return (
        <div className={styles.active_coupon}>
            <div className={styles.active_coupon_top}>
                <Row gutter={[20, 20]}>
                    <Col span={6}>
                        <div className={styles.coupon_img_container}>
                            <img src={coupon.product.image} alt={coupon.product.image} />
                            <div className={styles.coupon_img_attr}>
                                {coupon.product.is_bio && (
                                    <img
                                        src="https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/bio.svg"
                                        alt="bio"
                                    />
                                )}
                                {coupon.product.is_new && (
                                    <img
                                        src="https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/new.svg"
                                        alt="new"
                                    />
                                )}
                                {coupon.product.is_vegan && (
                                    <img
                                        src="https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/vegan.svg"
                                        alt="vegan"
                                    />
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col xs={18} lg={18}>
                        <div className={styles.coupon_product_name}>{coupon.product.name}</div>
                        <div className="d-flex gap-3 align-items-end">
                            <div className={styles.coupon_discount_amount}>0.39€ </div>
                            <div className={styles.coupon_price_amount}>(0.99€) </div>
                            <div className={styles.coupon_discount}>Save {coupon.discount}%</div>
                        </div>
                        <div className="fw-semibold">(10.73€/kg)</div>
                        <div className={styles.coupon_product_brand}>
                            {" "}
                            <strong>Brand: {coupon.product.brand}</strong>
                        </div>

                        <div> Valid only 1 product </div>
                    </Col>
                    {/* <Col xs={6} lg={0}>
                        {coupon.with_membership && <div className={styles.with_mem_title}>With Membership</div>}
                        {coupon.with_membership && (
                            <img
                                src="https://desi-fresh.b-cdn.net/components_static/ProductDescription/desi_family_card.svg"
                                alt="card"
                                className={styles.with_mem_card}
                            />
                        )}
                    </Col> */}
                </Row>
            </div>
            <div className={styles.active_coupon_bottom}>
                <p> Valid till {coupon.valid_until} </p>
                {coupon.is_new && (
                    <img
                        src="https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/new.svg"
                        alt="new"
                    />
                )}
                <Button type="primary"> Activate now </Button>
            </div>
        </div>
    );
};
